// extracted by mini-css-extract-plugin
export var page_section = "index-module--page_section--Am4u5";
export var page_section_title = "index-module--page_section_title--MWRWp";